import type { AccountInfo } from "@azure/msal-browser";
import { createContext } from "react";

export interface AuthContextValue {
  isAuthenticated: boolean;
  account: AccountInfo | null;
  login: () => Promise<void>;
  logout: () => void;
  getAccessToken: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
